import { render } from "./PopupCard.vue?vue&type=template&id=53d36048&scoped=true"
import script from "./PopupCard.vue?vue&type=script&lang=js"
export * from "./PopupCard.vue?vue&type=script&lang=js"

import "./PopupCard.vue?vue&type=style&index=0&id=53d36048&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d36048"]])

export default __exports__